// components/ui/Skeleton.tsx
import React from 'react';

// The loading state of a list is its own shape in a slow shimmer, as on ChatGPT, not a spinner
// and a 'Loading...' word. `skeleton-in` waits 150ms before showing it, so a fast load never
// flashes grey bars.
const WIDTHS = ['62%', '48%', '71%', '55%', '66%', '44%', '58%', '69%'];

export const SkeletonRows = ({ rows = 8 }: { rows?: number }) => (
  <div className="skeleton-in" aria-busy="true" aria-label="Loading" role="status">
    {Array.from({ length: rows }, (_, index) => (
      <div key={index} className="flex h-14 items-center gap-3 border-b border-white/[0.06] px-4">
        <div className="skeleton h-8 w-8 shrink-0 rounded-[8px]" />
        <div className="min-w-0 flex-1 space-y-2">
          <div className="skeleton h-3 rounded-full" style={{ width: `min(${WIDTHS[index % WIDTHS.length]}, 260px)` }} />
          <div className="skeleton h-2.5 w-24 rounded-full opacity-60" />
        </div>
        <div className="skeleton hidden h-3 w-[18%] max-w-[220px] rounded-full opacity-70 md:block" />
      </div>
    ))}
  </div>
);

export const SkeletonCards = ({ count = 8, className }: { count?: number; className?: string }) => (
  <div className={`skeleton-in ${className ?? ''}`} aria-busy="true" aria-label="Loading" role="status">
    {Array.from({ length: count }, (_, index) => (
      <div key={index}>
        <div className="skeleton aspect-[4/3] w-full rounded-[16px]" />
        <div className="skeleton mt-3 h-3 rounded-full" style={{ width: WIDTHS[index % WIDTHS.length] }} />
        <div className="skeleton mt-2 h-2.5 w-1/3 rounded-full opacity-60" />
      </div>
    ))}
  </div>
);
